import { ChevronDownIcon } from "@chakra-ui/icons";
import { Box, BoxProps, Collapse, Flex, Text } from "@chakra-ui/react";

// TODO ENG-8089: consistent spacing
const Collapsible: React.FC<
  {
    isOpen: boolean;
    label: string;
    toggleOpen: () => void;
    children: React.ReactNode;
  } & React.PropsWithChildren &
    BoxProps
> = ({ children, isOpen, label, toggleOpen, ...props }) => (
  <Box pl="16px" {...props}>
    <Flex onClick={toggleOpen} cursor="pointer" alignItems="center">
      <Text textStyle="overline">{label}</Text>
      <ChevronDownIcon
        as="button"
        width="20px"
        height="20px"
        color="gray.500"
        ml="8px"
        transform="auto"
        transitionProperty="common"
        transitionDuration="normal"
        rotate={isOpen ? 0 : -180}
      />
    </Flex>
    <Collapse in={isOpen}>{children}</Collapse>
  </Box>
);

export default Collapsible;
